export const tourOperatorRoute = "tour-partner";
export const tourOperatorRouteDashboard = `/${tourOperatorRoute}/dashboard`;
export const tourManageTours = `/${tourOperatorRoute}/managetours`;
export const tourManageMotorcycles = `/${tourOperatorRoute}/managemotorcycles`;
export const tourManageVAS = `/${tourOperatorRoute}/value-added-servives-list`;
export const tourBookings = `/${tourOperatorRoute}/bookings`;
export const tourTransactions = `/${tourOperatorRoute}/transactions`;
export const tourTransactionInvoicedetails = `/${tourOperatorRoute}/invoice-details`;
export const tourAccountInfo = `/${tourOperatorRoute}/account-info`;
export const tourManageLocation = `/${tourOperatorRoute}/manage-location`;
export const tourManageAccountUser = `/${tourOperatorRoute}/manage-account-user`;
export const tourEditAccountUser = `/${tourOperatorRoute}/edit-account-user`;
export const tourOperatorCancellationPolicy = `/${tourOperatorRoute}/terms-policy`;

export const tourAdd = `/${tourOperatorRoute}/add-tour`;
export const tourMangeLead = `/${tourOperatorRoute}/managetourlead`;
export const tourLeadEdit = `/${tourOperatorRoute}/tourleadedit`;
export const tourOverView = `/${tourOperatorRoute}/touroverview`;
export const tourTripAdd = `/${tourOperatorRoute}/tour-trip-add`;
export const manageRide = `/${tourOperatorRoute}/manage-ride`;
export const addRide = `/${tourOperatorRoute}/add-ride`;
export const rideDetails = `/${tourOperatorRoute}/ride-details/:id`;
export const tripinquiry = `/${tourOperatorRoute}/trip-inquiry`;

export const tourProfile = `/${tourOperatorRoute}/my-profile`;

// FAQ
export const tourOperatorFaq = `/${tourOperatorRoute}/partner-faq`;

//Operator Reviews
export const tourRatingsReviewsDetails = `/${tourOperatorRoute}/ratings-reviews-details`;

// Vas
export const tourValueAddedServices = `/${tourOperatorRoute}/value-added-servives`;

// Create Tour
export const tourCreate = `/${tourOperatorRoute}/create-tour`;

//Mobile and Desktop Preview
export const tourDesktop = `/${tourOperatorRoute}/preview`;
export const tourOverViewPrint = `/${tourOperatorRoute}/tour-overview-print`;

//Booking Details
export const tourPartnerBookingDetails = `/${tourOperatorRoute}/booking-details`;

//Booking Summary Details
export const tourBookingSummaryDetails = `/${tourOperatorRoute}/booking-summery`;

//Booking Summary Details Download Invoices
export const tourPartnerInvoicesCreditNote = `/${tourOperatorRoute}/invoices-credit-note`;

//Tour Reviews
export const tourPartnerReviews = `/${tourOperatorRoute}/tour-partner-review`;

export const tourLeadManagement = `/${tourOperatorRoute}/lead-management`;

export const tourLeadManagementDetails = `/${tourOperatorRoute}/pending-lead-details/:id`;

export const tourResourceManagement = `/${tourOperatorRoute}/resource-management`;
export const tourSupport = `/${tourOperatorRoute}/support`;
export const tourAddNewTicket = `/${tourOperatorRoute}/add-new-ticket`;
